var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarsSolid1DragBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1487_1375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.5C0.5 2.94687 0.946875 2.5 1.5 2.5H13.5C14.0531 2.5 14.5 2.94687 14.5 3.5C14.5 4.05313 14.0531 4.5 13.5 4.5H1.5C0.946875 4.5 0.5 4.05313 0.5 3.5ZM0.5 8.5C0.5 7.94688 0.946875 7.5 1.5 7.5H13.5C14.0531 7.5 14.5 7.94688 14.5 8.5C14.5 9.05312 14.0531 9.5 13.5 9.5H1.5C0.946875 9.5 0.5 9.05312 0.5 8.5ZM14.5 13.5C14.5 14.0531 14.0531 14.5 13.5 14.5H1.5C0.946875 14.5 0.5 14.0531 0.5 13.5C0.5 12.9469 0.946875 12.5 1.5 12.5H13.5C14.0531 12.5 14.5 12.9469 14.5 13.5Z",
    fill: "#343435"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1487_1375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsSolid1DragBar);
export default __webpack_public_path__ + "static/media/bars-solid 1DragBar.2670d4742a7a1bf0b5758f718503d87c.svg";
export { ForwardRef as ReactComponent };